export const __KEY__ = '_wptg_p2tg_';

export const PLUGIN_NAME = 'wptelegram-post-to-telegram';
